
import { request } from '@umijs/max';

// 纯获取服务商基本信息请求：只负责发请求
export async function fetchProviderInfo() {
    return request<API.BaseResponse<API.ProviderAccount>>('/v1/provider/account', {
        method: 'GET',
    });
}

// 纯获取服务当日营收信息：只负责发请求
export async function fetchCardData() {
    return request<API.BaseResponse<API.DailyStatsResponse>>('/v1/provider/daily_stats', {
        method: 'GET',
    });
}

// 纯获取最新消息：只负责发请求， 支持动态传分页参数，默认查第1页、每页8条
export async function fetchSysNoticeList(params: { page?: number; page_size?: number } = { page: 1, page_size: 8 }) {
    return request<API.BaseResponse<API.PageNotiylListResponse<API.NotificationsResponse>>>(
        '/v1/provider/notifications',
        {
            method: 'GET',
            params: {
                page: params.page || 1, // 兜底：默认查第1页
                page_size: params.page_size || 8, // 兜底：默认每页8条
            },
        }
    );
}

// 纯更新消息阅读：只负责发请求 { id?: number } - 如果不传 id，后端逻辑将执行“全部已读”
export async function updateNoticeStatus(params: { id?: number }) {
    return request<API.BaseResponse>('/v1/provider/notifications/read', {
        method: 'POST',
        data: params,
    });
}

// 纯获系统公告请求：只负责发请求，支持动态传分页参数，默认查第1页、每页8条
export async function fetchSystemAnnounList(params: { page?: number; page_size?: number } = { page: 1, page_size: 8 }) {
    return request<API.BaseResponse<API.PageListResponse<API.AnnouncementsResponse>>>(
        '/v1/provider/announcements',
        {
            method: 'GET',
            params: {
                page: params.page || 1, // 兜底：默认查第1页
                page_size: params.page_size || 8, // 兜底：默认每页8条
            },
        }
    );
}

// 纯获商户订单列表：只负责发请求，支持动态传分页参数，默认查第1页、每页8条
export async function fetchOrdersList(
    params: { page?: number; page_size?: number;[key: string]: any; } = { page: 1, page_size: 8 }
) {
    // 1. 解构参数，分离分页参数和业务搜索参数
    const { page = 1, page_size = 8, ...searchParams } = params;
    // 拼接动态参数，避免硬编码在URL中
    return request<API.BaseResponse<API.PageListResponse<API.OrderDataType>>>(
        '/v1/provider/orders',
        {
            method: 'GET',
            params: {
                page, // 分页：页码（兜底默认1）
                page_size, // 分页：页大小（兜底默认8）
                ...searchParams, // 👇 关键：传递所有搜索参数（如order_no、status、paid_at等）
            },
        }
    );
}

// 纯获商户订单列表：只负责发请求，支持动态传分页参数，默认查第1页、每页8条
export async function fetchDailyStatsList(
    params: { page?: number; page_size?: number;[key: string]: any; } = { page: 1, page_size: 8 }
) {
    // 1. 解构参数，分离分页参数和业务搜索参数
    const { page = 1, page_size = 8, ...searchParams } = params;
    // 拼接动态参数，避免硬编码在URL中
    return request<API.BaseResponse<API.PageListResponse<API.DailyStatsListResponse>>>(
        '/v1/provider/daily_stats_list',
        {
            method: 'GET',
            params: {
                page, // 分页：页码（兜底默认1）
                page_size, // 分页：页大小（兜底默认8）
                ...searchParams, // 👇 关键：传递所有搜索参数（如order_no、status、paid_at等）
            },
        }
    );
}

// 纯获修改登录密码：只负责发请求，{ old_password: string, new_password: string }
export async function updateLoginPassword(data: API.UpdatePasswordParams) {
    return request<API.BaseResponse>('/v1/provider/upassword', {
        method: 'POST',
        data,
    });
}

// 纯获取服务商结算列表：只负责发请求
export async function fetchSettleOrdersList(
    params: { page?: number; page_size?: number;[key: string]: any; } = { page: 1, page_size: 8 }
) {
    // 1. 解构参数，分离分页参数和业务搜索参数
    const { page = 1, page_size = 8, ...searchParams } = params;
    // 拼接动态参数，避免硬编码在URL中
    return request<API.BaseResponse<API.PageListResponse<API.SettleOrderResponse>>>(
        '/v1/provider/settle_orders',
        {
            method: 'GET',
            params: {
                page, // 分页：页码（兜底默认1）
                page_size, // 分页：页大小（兜底默认8）
                ...searchParams, // 👇 关键：传递所有搜索参数（如order_no、status、paid_at等）
            },
        }
    );
}

// 只负责发请求: 获取结算账户列表
export async function fetchSettlePayChannelList(type: string) {
    return request<API.BaseResponse<API.SettleChannelResponse[]>>(
        '/v1/provider/settle_channel_list',
        {
            method: 'GET',
            params: { type },
        }
    );
}

// 只负责发请求: 申请结算，并返回支付二维码
export async function submitSettleRequest(data: { amount: number; channerl_id: number; }) {
    return request<API.BaseResponse<any>>('/v1/provider/settle/apply', {
        method: 'POST',
        data,
    });
}
